import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';
interface Props {
	streaksDone: number;
}
const AboutStreak = ({ streaksDone }: Props) => {
	return (
		<Box mt="24px" textAlign={'center'}>
			<Heading as="h5" color="#0A0103">
				{streaksDone === 0 ? (
					'There’s no streak currently'
				) : (
					<>
						Yay! You've completed
						<br /> Day {streaksDone} in your streak
					</>
				)}
			</Heading>
			<Text mt="16px" textStyle="body2-md" color="#544D4F">
				{streaksDone == 0
					? `Practice, take quizzes and attend masterclasses daily/everyday to maintain those streaks. Each step you take counts towards building your
				career.`
					: 'Continue to practice, ace contests and attend masterclasses to keep that streak up! '}
			</Text>
		</Box>
	);
};

export default AboutStreak;
